'use strict';

import './src/assets/scss/init.scss';
import './static/css/prismjs/one-dark.css';
// import './src/assets/scss/copy/custom-code-buttons.scss';